import { inject } from 'vue';
import { useFieldArray, useForm, type FieldArrayContext, type FormContext } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import {
    createOcrFormSchema,
    type OcrFormValues,
    type OcrPayment,
    type OcrProduct,
} from 'composables/ocr/ocrFormSchema';
import type { Translator } from 'types/injects/translator.type';

export interface UseOcrFormOptions {
    initialValues: OcrFormValues;
}

interface UseOcrFormExtras {
    productsArray: FieldArrayContext<OcrProduct>;
    paymentsArray: FieldArrayContext<OcrPayment>;
}

export type UseOcrFormReturn = FormContext<OcrFormValues> & UseOcrFormExtras;

export const useOcrForm = (options: UseOcrFormOptions): UseOcrFormReturn => {
    const $t = inject('$t') as Translator;
    const validationSchema = toTypedSchema(createOcrFormSchema($t));

    const form = useForm<OcrFormValues>({
        validationSchema,
        validateOnMount: false,
        initialValues: options.initialValues,
    });

    const productsArray = useFieldArray<OcrProduct>('products');
    const paymentsArray = useFieldArray<OcrPayment>('payments');

    return {
        ...form,
        productsArray,
        paymentsArray,
    };
};
